module.exports = __webpack_public_path__ + "img/informacion.76db5677.png";